import React, { Component, ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorComponent } from 'components';
import { ErrorBoundaryProps, ErrorBoundaryState } from './types';

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error: Error): void {
    // Display fallback UI
    this.setState({ hasError: true });

    // According to the docs, this shouldn't be necessary
    Sentry.captureException(error);
  }

  render(): ReactNode {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <ErrorComponent
          title="Please Refresh"
          subtitle="Please refresh your page in order to finish processing this request."
          body="If you are still seeing this after attempting multiple times, please contact Scalar so we can help resolve the issue."
        />
      );
    }

    return children;
  }
}

export default ErrorBoundary;
